export const PRIVACY_POLICY = 'privacy-policy';
